import { apiFetch } from "../api.js";
import type {
  CreateIncomeEventInput,
  IncomeEvent,
  IncomeEventType,
  IncomeEventsListResponse,
  UpdateIncomeEventInput,
} from "./types.js";

export interface ListIncomeEventsArgs {
  readonly from?: string;
  readonly to?: string;
  readonly eventType?: IncomeEventType;
  readonly includeArchived?: boolean;
}

export function listIncomeEvents(
  args: ListIncomeEventsArgs = {},
): Promise<IncomeEventsListResponse> {
  const qs = new URLSearchParams();
  if (args.from) qs.set("from", args.from);
  if (args.to) qs.set("to", args.to);
  if (args.eventType) qs.set("event_type", args.eventType);
  if (args.includeArchived) qs.set("include_archived", "true");
  const tail = qs.toString();
  return apiFetch<IncomeEventsListResponse>(
    `/v1/income-events${tail ? `?${tail}` : ""}`,
  );
}

export function getIncomeEvent(
  date: string,
  eventId: string,
): Promise<IncomeEvent> {
  return apiFetch<IncomeEvent>(
    `/v1/income-events/${date}/${eventId}`,
  );
}

export function createIncomeEvent(
  input: CreateIncomeEventInput,
): Promise<IncomeEvent> {
  return apiFetch<IncomeEvent>("/v1/income-events", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function updateIncomeEvent(
  date: string,
  eventId: string,
  input: UpdateIncomeEventInput,
): Promise<IncomeEvent> {
  return apiFetch<IncomeEvent>(`/v1/income-events/${date}/${eventId}`, {
    method: "PATCH",
    body: JSON.stringify(input),
  });
}

export function deleteIncomeEvent(
  date: string,
  eventId: string,
): Promise<void> {
  return apiFetch<void>(`/v1/income-events/${date}/${eventId}`, {
    method: "DELETE",
  });
}
